import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';

import type { ChangeHistoryVersion } from '../changeHistoryMacroTypes.ts';

const styles = cssMap({
	commentCell: {
		whiteSpace: 'normal',
		wordBreak: 'break-word',
	},
});

export type VersionCommentProps = {
	version: ChangeHistoryVersion;
	isCurrent: boolean;
};

export const VersionComment = ({
	version,
	isCurrent,
}: VersionCommentProps): React.JSX.Element | null => {
	if (!version.message) {
		return null;
	}

	return (
		<Box xcss={styles.commentCell}>
			{isCurrent ? <Text as="strong">{version.message}</Text> : <Text>{version.message}</Text>}
		</Box>
	);
};
